<template>
  <div class="privacy">
    <h1>Privacy Policy</h1>

    This Privacy Policy describes how your personal information is collected, used, and shared when you visit or make a purchase from our website.

    <h2>WHAT PERSONAL INFORMATION WE COLLECT</h2>

    When you visit the Site, we automatically collect certain information about your device, including information about your web browser, IP address, time zone, and some of the cookies that are installed on your device.
    <br><br>
    Additionally, as you browse the Site, we collect information about the individual web pages or products that you view, what websites or search terms referred you to the Site, and information about how you interact with the Site. We refer to this automatically collected information as Device Information.
    <br><br>
    We collect Device Information using the following technologies:

    <ul>
      <li>Cookies are data files that are placed on your device or computer and often include an anonymous unique identifier.</li>
      <li>Log files track actions occurring on the Site, and collect data including your IP address, browser type, Internet service provider, referring/exit pages, and date/time stamps.</li>
    </ul>
    
    Also, when you make a purchase or attempt to make a purchase through the Site, we collect certain information from you, including your name, billing address, shipping address, payment information (including credit card numbers, payment method, email address, and phone number. This is called Order Information).
    <br><br>
    By Personal Information in this Privacy Policy, we are talking both about Device Information and Order Information.

    <h2>HOW DO WE USE YOUR PERSONAL INFORMATION</h2>

    We use the Order Information that we collect generally to fulfil any orders placed through the Site (including processing your payment information, arranging for shipping, and providing you with invoices and/or order confirmations).
    <br><br>
    Additionally, we use this Order Information to: - Communicate with you. - Screen our orders for potential risk or fraud. - When in line with the preferences you have shared with us, provide you with information or advertising relating to our products or services.
    <br><br>
    We use the Device Information that we collect to help us screen for potential risk and fraud (in particular, your IP address), and more generally to improve and optimize our Site.

    <h2>SHARING YOUR PERSONAL INFORMATION</h2>

    We share your Personal Information with third parties to help us use your Personal Information, as described above.
    <br><br>
    We also use Google Analytics to help us understand how our customers use our website. <a href="https://www.google.com/intl/en/policies/privacy/" target="_blank">How Google uses your Personal Information</a>.
    <br><br>
    Finally, we may also share your Personal Information to comply with applicable laws and regulations, to respond to a subpoena, search warrant or other lawful requests for information we receive, or to otherwise protect our rights.

    <h2>BEHAVIOURAL ADVERTISING</h2>

    We use your Personal Information to provide you with targeted advertisements or marketing communications we believe may be of interest to you.

    <ul>
      <li><a href="https://www.facebook.com/settings/?tab=ads" target="_blank">Facebook</a></li>
      <li><a href="https://www.google.com/settings/ads/anonymous" target="_blank">Google</a></li>
    </ul>
    
    You can opt out of targeted advertising...

    <h2>YOUR RIGHTS</h2>

    If you are a European resident, you have the right to access the personal information we hold about you and to ask that your personal information is corrected, updated, or deleted. If you would like to exercise this right, please contact us.
    <br><br>
    Additionally, if you are a European resident we note that we are processing your information in order to fulfil contracts we might have with you (for example if you make an order through the Site), or otherwise to pursue our legitimate business interests listed above.
    Please note that your information will be transferred outside of Europe, including to Canada and the United States.

    <h2>DATA RETENTION</h2>

    When you place an order through the Site, we will maintain your Order Information for our records unless and until you ask us to delete this information.


    <h2>CHANGES</h2>

    We may update this privacy policy from time to time in order to reflect, for example, changes to our practices or for other operational, legal or regulatory reasons.
    <br><br>
    If you have questions and/or require more information, do not hesitate to contact us.
  </div>
</template>

<script>
export default {
  name: "Privacy"
}
</script>

<style lang="scss" scoped>
  .privacy {

  }

  h2 {
    margin: 20px 0;
  }

  ul {
    margin: 20px 0;
    
    li {
      list-style-type: disc;
      margin-left: 20px;
    }
  }
</style>